import { render, staticRenderFns } from "./StartDocumentItem.vue?vue&type=template&id=6918dd32&scoped=true&"
import script from "./StartDocumentItem.vue?vue&type=script&lang=ts&"
export * from "./StartDocumentItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6918dd32",
  null
  
)

export default component.exports